export default {
  namespaced: true,
  // vuex存储公共状态的文件
  state: {
    isFixed: true,
    // 登陆
    token: localStorage.getItem('token') || '',
    // 用户角色
    role: localStorage.getItem('role') || '',
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
  },
  mutations: {
    NAV_IBFO (state, type) {
      state.isFixed = type
    },
    // 用户登陆后缓存用户信息
    INIT_LOGIN (state, { token, role, userInfo }) {
      // 将用户信息存储到state中
      state.token = token
      state.role = role
      state.userInfo = userInfo
      // 设置用户信息缓存
      localStorage.setItem('token', token)
      localStorage.setItem('role', role)
      // userInfo解析成JSON对象后存储
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    LOG_OUT (state) {
      localStorage.removeItem('token')
      localStorage.removeItem('role')
      localStorage.removeItem('userInfo')
    }
  }
}
